/* スクロールで要素が現れるときのアニメーション */
(function () {
  "use strict";

  /* 動きを減らす設定なら、何も付けずに終了（CSS側も無効になる） */
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  if (!("IntersectionObserver" in window)) return;

  document.documentElement.classList.add("fsj-reveal-on");

  var SELECTOR = [
    ".fsj-sechead",
    ".fsj-l-splitbleed__photo",
    ".fsj-l-split__photo",
    ".fsj-l-zigzag__photo",
    ".fsj-l-zigzag__text",
    ".fsj-l-pagehero__photo",
    ".fsj-top-gate__item",
    ".fsj-top-news__item",
    ".fsj-top-recruit__inner",
    ".fsj-services-item__inner",
    ".fsj-projects-value__inner",
    ".fsj-recruit-block__inner",
    ".fsj-recruit-jobs__item",
    ".fsj-recruit-person__item",
    ".fsj-recruit-voice__item",
    ".fsj-openings__item",
    ".fsj-beginners-voice__item",
    ".fsj-archive-item",
    ".fsj-about-company__body",
    ".fsj-about-message__body",
    ".fsj-cta-row",
    ".fsj-article__body"
  ].join(",");

  var targets = document.querySelectorAll(SELECTOR);
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-revealed");
      io.unobserve(entry.target); /* 一度出たら監視をやめる＝以降は一切計算しない */
    });
  }, {
    rootMargin: "0px 0px -18% 0px",
    threshold: 0.01
  });

  Array.prototype.forEach.call(targets, function (el) {
    el.classList.add("fsj-reveal");

    var parent = el.parentElement;
    if (parent) {
      var sibs = Array.prototype.filter.call(parent.children, function (c) {
        return c.classList && c.classList.contains("fsj-reveal");
      });
      var i = sibs.indexOf(el);
      if (i > 0 && sibs.length > 1 && sibs.length <= 12) {
        el.style.setProperty("--fsj-reveal-delay", Math.min(i, 4) * 150 + "ms");
      }
    }

    io.observe(el);
  });

  /* ---- 安全網 ---- */

  function revealIfVisible() {
    Array.prototype.forEach.call(targets, function (el) {
      if (el.classList.contains("is-revealed")) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add("is-revealed");
        io.unobserve(el);
      }
    });
  }

  /* ① 読み込み直後に画面内にあるぶんを出す */
  setTimeout(revealIfVisible, 400);

  setTimeout(function () {
    Array.prototype.forEach.call(targets, function (el) {
      if (!el.classList.contains("is-revealed")) {
        el.classList.add("is-revealed");
        io.unobserve(el);
      }
    });
  }, 4000);
})();
